var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75195 4.5C4.50932 4.5 3.50195 5.50736 3.50195 6.75V15.25C3.50195 16.4927 4.50931 17.5 5.75195 17.5H7.00195C7.41617 17.5 7.75195 17.8358 7.75195 18.25V19.7316L11.6406 17.5928C11.7513 17.5319 11.8756 17.5 12.002 17.5H18.252C19.4946 17.5 20.502 16.4927 20.502 15.25V6.75C20.502 5.50737 19.4946 4.5 18.252 4.5H5.75195ZM2.00195 6.75C2.00195 4.67894 3.68089 3 5.75195 3H18.252C20.323 3 22.002 4.67893 22.002 6.75V15.25C22.002 17.3211 20.323 19 18.252 19H12.1946L7.36339 21.6572C7.13104 21.785 6.84849 21.7806 6.62023 21.6456C6.39198 21.5106 6.25195 21.2652 6.25195 21V19H5.75195C3.6809 19 2.00195 17.3211 2.00195 15.25V6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble2);
export default __webpack_public_path__ + "static/media/bubble-2.b67bc5cb4be73807383461c0edade97e.svg";
export { ForwardRef as ReactComponent };